export default {
	setUserList(state, data) {
		if (data) {
			state.users = data;
		}
	},

	setRoleList(state, data) {
		if (data) {
			state.roles = data;
		}
	},

	createUser(state, data) {
		if (data) {
			state.users.push(data);
		}
	},
  
	editUser(state, data) {
		if (data) {
			const index = state.users.findIndex(user => user.id === data.id);
			state.users.splice(index, 1, data);
		}
	},
  
	deleteUser(state, data) {
		if (data) {
			state.users = state.users.filter(user => user.id !== data);
		}
	}
};
